import { OnboardingApp } from "onboarding/OnboardingApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const clientOnboardingRoute: RouteObject = {
  path: "clientonboarding",
  children: [{
    path: ":secret",
    loader: () => viewModel,
    Component: OnboardingApp,
  }]
};